const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeedometer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Speedometer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M128.315,413.685A223,223,0,0,1,271,33.507c-4.971-.328-9.972-.507-15-.507A223,223,0,0,0,98.315,413.685,221.542,221.542,0,0,0,256,479c5.028,0,10.029-.179,15-.507A221.348,221.348,0,0,1,128.315,413.685Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,19A237,237,0,0,0,88.416,423.584,237,237,0,1,0,423.584,88.416,235.445,235.445,0,0,0,256,19ZM413.685,413.685A223,223,0,0,1,98.315,98.315a223,223,0,0,1,315.37,315.37Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.9,118.808a7,7,0,0,0-13.8,0l-14,81A7,7,0,0,0,242,208h28a7,7,0,0,0,6.9-8.192ZM250.314,194,256,161.1l5.686,32.9Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.193,87a7,7,0,0,0,7-7V56a7,7,0,0,0-14,0V80A7,7,0,0,0,257.193,87Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.973,198.938l-23.324-5.654a7,7,0,0,0-3.3,13.606l23.324,5.654a7,7,0,1,0,3.3-13.606Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.082,150.4,98.823,137.536a7,7,0,0,0-7.506,11.818l20.26,12.867a7,7,0,0,0,7.5-11.819Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.558,93.189a7,7,0,0,0-10.912,8.772l15.035,18.707a7,7,0,0,0,10.913-8.772Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3,64.974a7,7,0,1,0-13.156,4.789l8.209,22.552a7,7,0,1,0,13.156-4.789Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.873,207.391a6.991,6.991,0,0,0,8.452,5.153l23.324-5.654a7,7,0,1,0-3.3-13.606l-23.324,5.654A7,7,0,0,0,413.873,207.391Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.761,160.064a7,7,0,0,0,9.662,2.157l20.26-12.867a7,7,0,1,0-7.506-11.818L395.918,150.4A7,7,0,0,0,393.761,160.064Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.283,92.119a7,7,0,0,0-9.841,1.07L356.406,111.9a7,7,0,0,0,10.913,8.772l15.035-18.707A7,7,0,0,0,381.283,92.119Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.672,62.79a7,7,0,0,0-8.972,4.184l-8.209,22.552a7,7,0,1,0,13.156,4.789l8.209-22.552A7,7,0,0,0,324.672,62.79Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,247a22,22,0,1,0,22,22A22.025,22.025,0,0,0,256,247Zm0,30a8,8,0,1,1,8-8A8.009,8.009,0,0,1,256,277Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,48C141.86,48,49,140.859,49,255a7,7,0,0,0,7,7H223.391a7,7,0,0,0,7-7,25.609,25.609,0,0,1,51.218,0,7,7,0,0,0,7,7H456a7,7,0,0,0,7-7C463,140.859,370.14,48,256,48Zm38.989,200a39.613,39.613,0,0,0-77.978,0H63.125C66.825,144.812,151.924,62,256,62s189.175,82.812,192.875,186Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/speedometer.e9209e8f89d767754369a2c09fae15ea.svg";
export { ForwardRef as ReactComponent };